export default `
query propertiesByServiceProvider($serviceProviderId: String!, $updatedAt: Float, $includeDeleted: Boolean, $first: Int, $after: String) {
	queryPropertiesByServiceProviderIdUpdatedAtIndex(
		serviceProviderId: $serviceProviderId,
		updatedAt: $updatedAt,
		includeDeleted: $includeDeleted,
		first: $first,
		after: $after
	) {
		items {
			variant
			patrolWindows {
				minsToStart
				minsToEnd
				darsRequired
			}
			geofence
			place {
				coordinates {
					lat
					lng
				}
				formattedAddress
				addressComponents {
					city
					state
					county
					country
					zipCode
					subpremise
					streetName
					neighborhood
					streetNumber
					zipCodeSuffix
				}
				timezone
			}
			isDeleted
			adminNote
			createdAt
			updatedAt
			propertyId
			instanceId
			instancedAt
			displayName
			cardinal {
				time {
					start
					end
				}
				indefiniteStart
				note
				indefinite
			}
			serviceProviderId
			serviceProviderNote
		}
		nextToken
	}
}
`;